import Handlebars from "handlebars/dist/handlebars.js";
import { Spinner } from "spin.js";
import moment from "moment";

$.widget("custom.chatticker", {
    options: {
        interval: null,
        roomids: ""
    },
    _create: function () {
        var $widget = this,
            $form = $widget.element,
            $container = $("ul", $form),
            template = Handlebars.compile($(".chattemplate", $form).html()),
            spinner = new Spinner(DefaultOptions.Spinner),
            ticker = $container.newsTicker({
                row_height: 40,
                max_rows: 1,
                duration: 10000,
                direction: "down",
                autostart: 0
            });

        $form.parent().hide();

        Handlebars.registerHelper("format-date", function (date, options) {
            return moment(date).fromNow();
        });

        var populateChats = function () {
            ticker.newsTicker("stop");
            spinner.spin($form.get(0));

            $.getJSON(Urls.ChatTicker, { roomIds: $widget.options.roomids, _: new Date().getTime() }, function(data) {
                if (data.ChatMessages.length === 0) {
                    $form.parent().hide();
                } else {
                    $form.parent().show();

                    for (var i in data.ChatMessages) {
                        if (!data.ChatMessages.hasOwnProperty(i)) continue;
                        data.ChatMessages[i].Content = new Handlebars.SafeString(data.ChatMessages[i].Content);
                    }

                    $container.fadeOut().html(template(data.ChatMessages)).fadeIn(500);
                    ticker.newsTicker("start");
                }
                spinner.stop();
            });
        };
        setTimeout(function () {
            populateChats();
        }, 800);
        $widget.options.interval = setInterval(populateChats, 2 * 60 * 1000);
    },
    _destroy: function () {
        var $widget = this;
        if ($widget.options.interval)
            clearInterval($widget.options.interval);
    }
});